// extracted by mini-css-extract-plugin
export default {"chip":"Album_chip__AaIZp"};